export const PHONE_DISPLAY = '+90 544 110 14 92';
export const WHATSAPP_NUMBER = '905441101492';
export const INSTAGRAM_HANDLE = '@villagarage90';
export const INSTAGRAM_URL = 'https://www.instagram.com/villagarage90';
export const WHATSAPP_BASE = 'https://wa.me/' + WHATSAPP_NUMBER;